import { Toaster as Sonner, toast } from "sonner"

// Operator-UI Toast (COMPONENTS.md Toast / Modal): surface-raised gradient,
// radius 12, border .1, shadow.3; only the action uses the Light button.
// The admin is dark only, so the toaster is pinned to "dark" (it used to follow
// next-themes' "system", which rendered LIGHT toasts on a light-mode OS because
// no ThemeProvider is mounted). The look lives in index.css (.mb-toast).
const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: "mb-toast",
          title: "mb-toast-title",
          description: "mb-toast-description",
          actionButton: "mb-toast-action",
          cancelButton: "mb-toast-cancel",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
